<template>
  <section class="address-container">
    <div class="module-title-s" />
    <div class="address-main">
      <div class="address-info">
        <div class="address-box" style="margin-bottom: 5.5rem" v-if="data.subway !== ''">
          <span class="address-title">地铁</span>
          <div class="address-text" v-html="data.subway" />
        </div>
        <div class="address-box" v-if="data.bus !== ''">
          <span class="address-title">公交</span>
          <div class="address-text" v-html="data.bus" />
        </div>
      </div>
      <div class="address-img">
        <img :src="data.img || IMG_LIST.NO_DATA_IMG" alt />
        <div class="address-site">
          <div class="address-area" />
          <div class="address-pos" />
          <div class="address-tit">爱奇艺动漫游戏嘉年华 · {{ cityName }}站</div>
        </div>
        <div class="address-box">
          <span class="address-title">展会地址</span>
          <div class="address-text" v-html="data.location" />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { IMG_LIST } from '../mock-data'

export default {
  data() {
    return {
      IMG_LIST,
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    cityName: {
      type: String,
      default: '',
    },
  },
  watch: {
    data: {
      handler(newValue) {
        this.data.location = newValue.location.replace(/\n/g, '<br/>')
        this.data.subway = newValue.subway.replace(/\n/g, '<br/>')
        this.data.bus = newValue.bus.replace(/\n/g, '<br/>')
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {},
}
</script>
<style lang="less">
.address-container {
  position: relative;
  max-width: 112.2rem;
  margin: 0 auto 8rem;
  .module-title-s {
    background-image: url('../images/title-s-zn.png');
  }
  .address-main {
    width: 112.2rem;
    height: 61.1rem;
    background: url('../images/address-bg.png') no-repeat 0 0;
    background-size: 100% auto;

    .address-img {
      position: absolute;
      right: 1rem;
      bottom: 2rem;
      background: #2f15a2;
      background: linear-gradient(-45deg, transparent 3rem, #2f15a2 0);
      width: 58.3rem;
      height: 57.2rem;
      margin-left: 1.4rem;
      flex-shrink: 0;

      img {
        position: absolute;
        top: 0.2rem;
        left: 0.1rem;
        z-index: 2;
        width: 58.1rem;
        height: 56.8rem;
        clip-path: polygon(0 0, 100% 0, 100% 52.6rem, 53.9rem 100%, 0 100%);
      }

      .address-box {
        position: absolute;
        bottom: 4.5rem;
        left: 5.6rem;
        z-index: 2;
        text-align: left;
        .address-title {
          position: relative;
          top: -0.8rem;
          left: -0.8rem;
          text-align: center;
          background: #330ad6;
          line-height: 2.6rem;
          font-weight: 750;
          font-size: 2rem;
          color: #ffffff;
          padding: 0.5rem 0.9rem 0.3rem 1.3rem;
        }
        .address-text {
          width: 47.9rem;
          box-sizing: border-box;
          line-height: 2.4rem;
          padding: 1.8rem 2.3rem 1.7rem 2.5rem;
          background: #ffa9f7;
          border: 0.2rem solid #330ad6;
          box-shadow: -0.8rem -0.8rem 0 #330ad6;
          font-size: 1.8rem;
          font-weight: 500;
          color: #330ad6;
          text-shadow: 0 1rem 1.8rem 0.5rem rgba(30, 3, 120, 0.26);
        }
      }
    }

    .address-site {
      position: absolute;
      z-index: 2;
      top: 20.8rem;
      left: 12.5rem;
      .address-area {
        width: 12.6rem;
        height: 15.3rem;
        background: rgba(74, 218, 254, 0.2);
        border: 0.2rem solid #330ad6;
      }
      .address-pos {
        position: absolute;
        top: 2.4rem;
        left: 4rem;
        width: 4.3rem;
        height: 5.7rem;
        background: url('../images/position.png') no-repeat;
        background-size: contain;
      }
      .address-tit {
        position: relative;
        top: -19.1rem;
        left: 6rem;
        padding: 0.5rem 1.4rem;
        max-width: 31.6rem;
        text-align: center;
        box-sizing: border-box;
        border: 0.3rem solid #330ad6;
        background: #7de4fe;
        box-shadow: 0.6rem -0.6rem #330ad6;
        color: #330ad6;
        font-size: 1.8rem;
        font-weight: 500;
        line-height: 2.4rem;
        &::before,
        &::after {
          position: absolute;
          display: inline-block;
          content: '';
        }
        &::before {
          left: -0.3rem;
          bottom: -1.8rem;
          border-top: 1.6rem solid transparent;
          border-bottom: 1.6rem solid transparent;
          border-left: 2rem solid #330ad6;
          z-index: 1;
        }
        &::after {
          left: 0;
          bottom: -1.3rem;
          border-top: 1.4rem solid transparent;
          border-bottom: 1.4rem solid transparent;
          border-left: 1.6rem solid #7de4fe;
          z-index: 3;
        }
      }
    }
  }

  .address-info {
    position: absolute;
    left: 3.5rem;
    top: 50%;
    transform: translateY(-45%);
    .address-box {
      width: 47.9rem;
      font-size: 0;
      text-align: left;
    }
    .address-title {
      position: relative;
      top: -1rem;
      left: -0.8rem;
      text-align: center;
      background: #1f037a;
      padding: 0.6rem 0.9rem;
      line-height: 2.6rem;
      font-weight: 750;
      font-size: 2rem;
      color: #ffffff;
    }
    .address-text {
      padding: 1.8rem 2.3rem 1.7rem 2.5rem;
      background: #f0fcff;
      border: 0.2rem solid #1f037a;
      box-shadow: -0.8rem -0.8rem 0 #1f037a;
      line-height: 2.4rem;
      text-align: left;
      font-size: 1.8rem;
      color: #330ad6;
    }
  }
}
.carnival-ip-container .address-container {
  margin: 0 auto 3rem;
}
</style>
